import React from "react";
import {
  Typography,
  Grid,
  RadioGroup,
  Radio,
} from "@material-ui/core";
import ProfileImg from '@icarius-common/profileImg';
import CustomDisabledCheckedIcon from "./customDisabledCheckedIcon";

const Ona = (props) => {

  const {
    options,
    colaboratorList,
    isCompleted,
    onChange,
    value,
  } = props;

  const handleChange = (e, rowId) => {
    let newValue = Array.isArray(value) ? [...value] : [];
    const existingIndex = newValue.findIndex((el) => el.key === rowId);
    if (existingIndex !== -1) newValue[existingIndex] = { ...newValue[existingIndex], value: e.target.value };
    else newValue.push({ key: rowId, value: e.target.value });

    onChange(newValue);
  }

  return (
    <div style={{ marginTop: 16 }}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Grid container wrap="nowrap" alignItems="center">
            <Grid item style={{ width: '30%', flexShrink: 0 }}></Grid>
            {
              options?.map((option) => (
                <Grid
                  item align="center" key={option}
                  style={{ flex: 1, flexShrink: 0, padding: '0 4px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                >
                  <Typography
                    variant="body2"
                    style={{ color: 'var(--mainText)', fontWeight: 600, lineHeight: 1.2, display: 'block', fontSize: '0.9rem', textAlign: 'center' }}
                  >
                    {option}
                  </Typography>
                </Grid>
              ))
            }
          </Grid>
        </Grid>
        {
          colaboratorList?.map((colaborator) => {
            const rowId = colaborator.key;
            const rowName = colaborator.value;
            const rowValue = (value || []).find(el => el.key === rowId)?.value;

            return (
              <Grid item xs={12} key={rowId}>
                <RadioGroup
                  value={rowValue || ''}
                  onChange={(e) => {
                    if (isCompleted) return;
                    handleChange(e, rowId);
                  }}
                  style={{ width: '100%', flexWrap: 'nowrap' }}
                  row
                >
                  <Grid container wrap="nowrap" alignItems="center">
                    <Grid item style={{ width: '30%', flexShrink: 0, paddingRight: 8, display: 'flex', alignItems: 'center' }}>
                      <div style={{ marginRight: 12 }}>
                        <ProfileImg image={colaborator.img} size={40} />
                      </div>
                      <Typography style={{ color: 'var(--mainText)', fontSize: '1rem' }}>
                        {rowName}
                      </Typography>
                    </Grid>
                    {
                      options?.map((option) => (
                        <Grid item style={{ flex: 1, flexShrink: 0, display: 'flex', justifyContent: 'center' }} key={option}>
                          <Radio
                            value={option}
                            color="primary"
                            size="small"
                            {...(isCompleted ? { checkedIcon: <CustomDisabledCheckedIcon /> } : undefined)}
                            disabled={isCompleted}
                          />
                        </Grid>
                      ))
                    }
                  </Grid>
                </RadioGroup>
              </Grid>
            );
          })
        }
      </Grid>
    </div>
  );
}

export default Ona;